export const appBarStyle = {
  boxShadow: "none",
  borderBottom: "1px #E4EBE0 solid",
  color: "transparent",
}

export const toolbarStyle = {
  minHeight: { xs: 64, md: 72, lg: 80 },
}
